
<div class="one-whole-adfsclient ml-adfsclient">
    <h2 class="heading-adfsclient">{{'Registered ADFS Clients'|translate}}</h2>
    <p class="p-adfsclient">{{'Registered ADFS clients that are set and allowed to acccess webservies via Etis'|translate}}</p>
    <div class="one-whole-adfsclient">
        
        <div><input class="btn-adfsclient addadfsclientbtn" type="button" (click)="addAdfs(addadfsclient)" value="{{'ADD'|translate}}">

        </div>
        <table class="table__thin tablesorter table">
            <thead class="table__headings">
                <tr>

                    <th class="cid-w-adfsclient">{{'Client ADFS ID'|translate}}</th>
                    <th class="cid-w-adfsclient">{{'Application Name'|translate}}</th>
                    <th class="cid-w-adfsclient">{{'Contact Info'|translate}}</th>
                    <th class="cid-w-adfsclient"></th>

                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let i of adfsList;">
                    <td>{{i.clientID}}</td>
                    <td>{{i.applicationName}}</td>
                    <td>{{i.contactInfo}}</td>

                    <td class="buttontd-adfsclient">
                        <input class="btn-adfsclient" (click)="editAdfs(i.id,i.clientID,i.applicationName,i.contactInfo,i.restrictedAccess,i.lastUsed,editAdfsClient)"
                            type="button" value="{{'VIEW'|translate}} / {{'EDIT'|translate}}">&nbsp;
                        <input class="btn-adfsclient" (click)="deleteAdfsClient(i.id,deletePopUpAdfsClient)"

                            type="button" value="{{'DELETE'|translate}}">
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
<div class="modal-dialog modal-lg">
    <ng-template #addadfsclient let-modal>

        <div class="popup-border-adfsclient">
            <div class="modal-header-adfsclient">
                <span class="header-popup-text-adfsclient">{{'Add new ADFS Client'|translate}}</span>
                <i class="fa fa-times mng-qualifier-close-btn close-adfsclient-popup"
                    (click)="modal.dismiss('Cross click');clearVariables()" title="close"></i>
            </div>
            <div class="input-box-adfsclient">
                
                {{'Client ADFS ID'|translate}}
                <input type="text" class="pop-w-input-adfsclient" name="adfsClientId" [(ngModel)]="adfsClientId">
                <div *ngIf="erroradfsClientId" class="error-adfs-border">
                    <span class="fa fa-exclamation-triangle"></span>&nbsp;
                    <span class="adderror-adfsclient">{{'Client ADFS ID is empty'|translate}}</span>
                </div>
                <div *ngIf="erroradfsClientId1" class="error-adfs-border">
                    <span class="fa fa-exclamation-triangle"></span>&nbsp;
                    <span class="adderror-adfsclient">{{'Client ADFS ID exists already'|translate}} </span>
                </div>
                <div *ngIf="erroradfsClientIdLength" class="error-adfs-border">
                    <span class="fa fa-exclamation-triangle"></span>&nbsp;
                    <span class="adderror-adfsclient">{{'Client ADFS ID is too long'|translate}} </span>
                </div>
               
                {{'Application Name'|translate}}
                <input type="text" class="pop-w-input-adfsclient" name="adfsName"
                    [(ngModel)]="adfsName">
                <div *ngIf="erroradfsName" class="error-adfs-border">
                    <span class="fa fa-exclamation-triangle"></span>&nbsp;
                    <span class="adderror-adfsclient">{{'Application name is missing'|translate}}</span>
                </div>
                <div *ngIf="erroradfsNameLength" class="error-adfs-border">
                    <span class="fa fa-exclamation-triangle"></span>&nbsp;
                    <span class="adderror-adfsclient">{{'Application name is too long'|translate}}</span>
                </div>

                {{'Contact Info'|translate}}
                <input type="text" class="pop-w-input-adfsclient" name="adfsContact"
                    [(ngModel)]="adfsContact">
                <div *ngIf="erroradfsContact" class="error-adfs-border">
                    <span class="fa fa-exclamation-triangle"></span>&nbsp;
                    <span class="adderror-adfsclient">{{'Contact Info is missing'|translate}}</span>
                </div>
                <div *ngIf="erroradfsContactLength" class="error-adfs-border">
                    <span class="fa fa-exclamation-triangle"></span>&nbsp;
                    <span class="adderror-adfsclient">{{'Contact Info is too long'|translate}}</span>
                </div>
                
               
            </div>
            <div class="modal-footer">
                

                <input class="input-btn-adfsclient" type="button" value="{{'SUBMIT'|translate}}" (click)="setsubmiteditadfsclientAdd(adfsClientId,adfsName,adfsContact)">
                &nbsp;&nbsp;<input class="input-btn-adfsclient" type="button" value="{{'CLOSE'|translate}}"

                    (click)="modal.close('Close click');clearVariables();">
            </div>
        </div>
    </ng-template>
</div>
<div class="modal-dialog modal-lg">
    <ng-template #editAdfsClient let-modal>

        <div class="popup-border-adfsclient">
            <div class="modal-header-adfsclient">
                <span class="header-popup-text-adfsclient">{{'Update ADFS Client'|translate}}</span>
                <i class="fa fa-times mng-qualifier-close-btn close-adfsclient-popup"
                    (click)="modal.dismiss('Cross click');clearVariables()" title="close"></i>
            </div>
            <div class="input-box-adfsclient">
               {{'Client ADFS ID'|translate}}
                <input type="text" class="pop-w-input-adfsclient" name="adfsClientIdUp" [(ngModel)]="adfsClientIdUp">
               
                <div *ngIf="erroradfsClientIdUp" class="error-adfs-border">
                    <span class="fa fa-exclamation-triangle"></span>&nbsp;
                    <span class="adderror-adfsclient">{{'Client ADFS ID is empty'|translate}}</span>
                </div>
                <div *ngIf="erroradfsClientIdUp1" class="error-adfs-border">
                    <span class="fa fa-exclamation-triangle"></span>&nbsp;
                    <span class="adderror-adfsclient">{{'Client ADFS ID exists already'|translate}} </span>
                </div>
                <div *ngIf="erroradfsClientIdUpLength" class="error-adfs-border">
                    <span class="fa fa-exclamation-triangle"></span>&nbsp;
                    <span class="adderror-adfsclient">{{'Client ADFS ID is too long'|translate}} </span>
                </div>
                {{'Application Name'|translate}}
                <input type="text" class="pop-w-input-adfsclient" name="adfsNameUp"
                    [(ngModel)]="adfsNameUp">
                <div *ngIf="erroradfsNameUp" class="error-adfs-border">
                    <span class="fa fa-exclamation-triangle"></span>&nbsp;
                    <span class="adderror-adfsclient">{{'Application name is missing'|translate}}</span>
                </div>
                <div *ngIf="erroradfsNameUpLength" class="error-adfs-border">
                    <span class="fa fa-exclamation-triangle"></span>&nbsp;
                    <span class="adderror-adfsclient">{{'Application name is too long'|translate}}</span>
                </div>
                {{'Contact Info'|translate}}
                <input type="text" class="pop-w-input-adfsclient" name="adfsContactUp"
                    [(ngModel)]="adfsContactUp">
                <div *ngIf="erroradfsContactUp" class="error-adfs-border">
                    <span class="fa fa-exclamation-triangle"></span>&nbsp;
                    <span class="adderror-adfsclient">{{'Contact Info is missing'|translate}}</span>
                </div>
                <div *ngIf="erroradfsContactUpLength" class="error-adfs-border">
                    <span class="fa fa-exclamation-triangle"></span>&nbsp;
                    <span class="adderror-adfsclient">{{'Contact Info is too long'|translate}}</span>
                </div>
                <div class="radio_button">
                {{'Restricted Access'|translate}}
                <span>
                    <span class="radio-btn">
                        <input type="radio" [value]="true"
                            [(ngModel)]="restrictedAccess" checked
                            name="restrictedAccess">&nbsp;{{'true'|translate}}
                        </span>
                        <span>
                       <input type="radio" [value]="false"
                     name="restrictedAccess"
                            [(ngModel)]="restrictedAccess">&nbsp;{{'false'|translate}}
                        </span>
                </span><br>
            </div> 
                {{'Date Of Last Access'|translate}}
                <input type="text" class="pop-w-input-adfsclient" name="adfsDateUp"
                    [(ngModel)]="adfsDateUp"  readonly>
                <div class="webservices-header">
                    <span class="header-popup-text-adfsclient">{{'Authorized webservices'|translate}}</span>
                     </div><br>
                     <div class="webservices-msg" *ngFor="let i of adfsWebservices" style="margin-bottom: 5px;">
                     {{i.name}}
                    </div>
            </div>
            <div class="modal-footer">
                
                <input class="input-btn-adfsclient" type="button" value="{{'SUBMIT'|translate}}" (click)="setsubmiteditadfsclientedit(adfsClientIdUp,adfsNameUp,adfsContactUp,restrictedAccess)" >
                &nbsp;&nbsp;<input class="input-btn-adfsclient" type="button" value="{{'CLOSE'|translate}}"

                    (click)="modal.close('Close click');clearVariables()">
            </div>
        </div>
    </ng-template>
</div>
<div class="modal-dialog modal-sm">
    <ng-template #deletePopUpAdfsClient let-modal>

        <div class="popup-border-adfsclient">
            <div class="modal-header-adfsclient">{{'Delete Client'|translate}}
                <i class="fa fa-times mng-qualifier-close-btn close-adfsclient-popup"
                    (click)="modal.dismiss('Cross click');clearVariables()" title="close"></i>
            </div>
            <div class="padding-adfsclient">
                <label>{{'Are you sure you want to delete this client'|translate}}</label>
            </div>
            <div class="modal-footer">
              
                <input class="input-btn-adfsclient" type="button" value="{{'Ok'|translate}}"
                    (click)="modal.dismiss('deletePopUpAdfsClient');deletePopcredentialadfsclient();">
                &nbsp;&nbsp;
                <input class="input-btn-adfsclient" type="button" value="{{'CLOSE'|translate}}"

                    (click)="modal.close('Close click');clearVariables()">
            </div>
        </div>
    </ng-template>
</div>
<div *ngIf="isBackToTopShowBtn" (scroll)="onScroll($event)" class="back-to-top-adfsclient" style="display: block;"
    (click)="topFunction()">